import React from 'react';
import { connect } from 'react-redux';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import { showError } from 'actions/CommonActions';
import { getPurchaseOrderProduct} from 'actions/EntityActions';
import { clearFormInput } from 'actions/FormActions';
import LOOKUP from 'constants/lookup';
import DialogConfirm from 'screens/components/basic/DialogConfirm';
import ScanBarcode from './ScanBarcode';
import ReceivedQty from './ReceivedQty';

/**
 * Horizontal steppers are ideal when the contents of one step depend on an earlier step.
 * Avoid using long step names in horizontal steppers.
 *
 * Linear steppers require users to complete one step in order to move on to the next.
 */
const SCAN_UPC_NUMBER_STEP = 0;
const RECEIVE_PRODUCT_QNT_STEP = 1;
const TOTAL_STEPS = 1;

class ReceiveProductDialog extends React.Component {
  constructor(props) {
    super(props);
    this.goUPCCode = this.goUPCCode.bind(this);
  }

  state = {
    finished: false,
    stepIndex: SCAN_UPC_NUMBER_STEP,
    productInfo: {
      id: this.props.product.productId,
      upc: '',
      lot: '',
      quantity: 0,
      accessory: false,
      categoryName: '',
      legalBarCode: '',
      productName: '',
      price: 0.00,
      sku: this.props.product.sku
    },
    upcExists: false
  };

  componentDidMount(){
    const currentProductId = this.props.product.id;
    if (currentProductId){
      this.props.getPurchaseOrderProduct(currentProductId);
    }
  }

  componentWillReceiveProps(newProps) {
    if (this.props.receivedPOProduct != newProps.receivedPOProduct && newProps.receivedPOProduct){
      const product = newProps.receivedPOProduct;
      this.setState({
        productInfo: {
          id: product.id,
          upc: '',
          lot: '',
          quantity: 0,
          accessory: product.accessory,
          categoryName: product.category,
          legalBarCode: product.legalBarCode,
          productName: product.product,
          productId: product.productId,
          price: "$" + product.salePrice.toFixed(2),
          sku: product.sku
        },
      })
    }
    if (this.props.receivePOBarcodeExist != newProps.receivePOBarcodeExist && newProps.receivePOBarcodeExist == true) {
      this.setState({
        upcExists: true
      })
    }

    if (newProps.receiveProductSuccessKey != null && newProps.receiveProductSuccessKey != undefined && newProps.receiveProductSuccessKey != this.props.receiveProductSuccessKey) {
      newProps.handleDialog();
      setTimeout(newProps.cleanQty, 1000);
    }
  }

  componentWillUnmount() {
    this.props.clearFormInput("InputLotNumber");
  }

  handleUpc = (value) => {
    this.setState(prevState => {
      return {
        ...prevState,
        productInfo: {
          ...prevState.productInfo,
          upc: value
        }
      }
    });
  }

  clearHandleUpc = () => {
    this.setState(prevState => {
      return {
        ...prevState,
        productInfo: {
          ...prevState.productInfo,
          upc: ""
        }
      }
    });
  }


  handleNext = () => {
    const { stepIndex } = this.state;
    const { upc, accessory } = this.state.productInfo;
    if (stepIndex < TOTAL_STEPS) {
      if (this.props.inputLotNumber != "" && this.props.inputLotNumber != null && this.props.inputLotNumber != undefined) {
        console.log("I want to receive lot#!");
      } else if (!this.props.isMedical && !this.props.isVape && !accessory) {
        let expirationDate, expirationDateString = null;
        let upcNumber = (this.props.InputUPCNumber) ? this.props.InputUPCNumber : upc;
        upcNumber = upcNumber.replace(/\(|\)/gi, "").replace(/^\]C1/, '');
        if (upcNumber.length < 26 || upcNumber.length > 100) {
          this.props.showError("This product is set to Legal Barcode, please scan a correct barcode 2D fromat.");
          return;
        } else {
          // first two digits are application identifier (AI) for UPC
          let UPCIdentifier = upcNumber.substring(0, 2);
          // deigit 16 to 18 is for the AI for expiration date
          let expirationDateIdentifier = upcNumber.substring(16, 18);
          let expirationDateValue = upcNumber.substring(18, 24);
          // deigit 24 to 26 is for the AI for expiration date
          let lotNumberIdentifier = upcNumber.substring(24, 26);
          if (UPCIdentifier != "01" || (expirationDateIdentifier != "17" && expirationDateIdentifier != "13" && expirationDateIdentifier != "11") || lotNumberIdentifier != "10" || isNaN(parseInt(expirationDateValue))) {
            this.props.showError("Please Scan Or Input A Correct BarCode!");
            return;
          } else {
            expirationDateString = upcNumber.substring(18, 24);
            expirationDate = this.createExpirationDate(expirationDateString);
            this.setState({
              expirationDate: expirationDate
            });
          }
        }
      }
      this.setState({
        stepIndex: stepIndex + 1,
        finished: stepIndex >= TOTAL_STEPS
      });
    } else {
      //Checking the lot number
      if (this.props.inputLotNumber != "" && this.props.inputLotNumber != null && this.props.inputLotNumber != undefined) {
        this.props.receiveProduct(this.props.inputLotNumber, "", false, this.props.receivedQuantityDialog, this.props.expirationDate);
      } else {
        let lotNumber, expirationDate, expirationDateString = null;
        let upcNumber = (this.props.InputUPCNumber) ? this.props.InputUPCNumber : upc;
        upcNumber = upcNumber.replace(/\(|\)/gi, "").replace(/^\]C1/, '');
        let realUPC = "";
        if (this.props.isMedical || this.props.isVape) {
          lotNumber = '';
        } else {
          if (!accessory) {
            realUPC = parseInt(upcNumber.substring(2, 16)).toString();
            expirationDateString = upcNumber.substring(18, 24);
            expirationDate = this.createExpirationDate(expirationDateString);
            lotNumber = upcNumber.substring(26);
          } else {
            realUPC = upcNumber;
            lotNumber = '';
          }
        }
        this.props.receiveProduct(lotNumber, realUPC, accessory, this.props.receivedQuantityDialog, expirationDate);
      }

    }
  }

  //dateString format = YYMMDD
  createExpirationDate(dateString) {
    let year = parseInt("20" + dateString.substring(0, 2));
    let month = parseInt(dateString.substring(2, 4));
    let day = parseInt(dateString.substring(4, 6));
    return new Date(year, (month - 1), day);
  }

  goUPCCode() {
    this.setState(prevState => {
      return {
        ...prevState,
        stepIndex: SCAN_UPC_NUMBER_STEP,
        productInfo: {
          ...prevState.productInfo,
          accessory: true
        }
      }
    });
  }

  handlePrev = () => {
    const { stepIndex } = this.state;
    if (stepIndex > SCAN_UPC_NUMBER_STEP) {
      this.setState({ stepIndex: stepIndex - 1 });
    }
  };

  getStepContent(stepIndex) {
    switch (stepIndex) {
      case SCAN_UPC_NUMBER_STEP:
        return (<ScanBarcode setUpc={this.handleUpc} isMedical={this.props.isMedical} isVape={this.props.isVape} productInfo={this.state.productInfo} store={this.props.store} ws={this.props.ws} printQuantity={this.props.printQuantity} />);
      case RECEIVE_PRODUCT_QNT_STEP:
        return (<ReceivedQty productInfo={this.state.productInfo} max={this.props.product ? this.props.product.quantity - this.props.product.actualQuantity : 0} expirationDate={this.state.expirationDate} />);
      default:
        return 'Follow steps to add received products';
    }
  }

  clearExistUPC = () => {
    this.setState({ upcExists: false });
    this.props.clearFormInput("receivePOBarcodeExist");
    this.props.clearFormInput("receivePOUPCExistProductName");
  }

  cancelChangeUPC = () => {
    this.clearExistUPC();
  }

  changeUPCandReceive = () => {
    this.clearExistUPC();
    const { upc, accessory } = this.state.productInfo;
    let lotNumber, expirationDate, expirationDateString = null;
    let upcNumber = (this.props.InputUPCNumber) ? this.props.InputUPCNumber : upc;
    upcNumber = upcNumber.replace(/\(|\)/gi, "").replace(/^\]C1/, '');
    let realUPC = "";
    if (this.props.isMedical || this.props.isVape) {
      lotNumber = '';
    } else {
      if (!accessory) {
        realUPC = parseInt(upcNumber.substring(2, 16)).toString();
        expirationDateString = upcNumber.substring(18, 24);
        expirationDate = this.createExpirationDate(expirationDateString);
        lotNumber = upcNumber.substring(26);
      } else {
        realUPC = upcNumber;
        lotNumber = '';
      }
    }
    this.props.receiveProduct(lotNumber, realUPC, accessory, this.props.receivedQuantityDialog, expirationDate, true);
  }

  render() {
    const { finished, stepIndex } = this.state;
    const contentStyle = { margin: '0 16px' };

    return (
      <div style={{ width: '100%', maxWidth: 700, margin: 'auto', marginTop: '5px' }}>
        <Stepper activeStep={stepIndex}>
          <Step>
            <StepLabel>Scan Barcode</StepLabel>
          </Step>
          <Step>
            <StepLabel>Add Receive Quantity</StepLabel>
          </Step>
        </Stepper>

        <div className="product-name-receive-po">
          {this.props.productName} ({this.props.isVape ? 'Vape' : (this.props.product ? this.props.product.accessory ? 'Accessory' : 'Cannabis' : ``)})
        </div>

        <div style={contentStyle}>
          {finished ? (
            <p>
              <a
                href="#"
                onClick={(event) => {
                  event.preventDefault();
                  this.setState({ stepIndex: SCAN_UPC_NUMBER_STEP, finished: false });
                  this.props.handleDialog;
                }}
              >
              </a>
            </p>
          ) : (
            <div>
              {/** Returns a Component for the report */}
              <div>{this.getStepContent(stepIndex)}</div>

              <div style={{ marginTop: 12, marginBottom: 24 }}>
                <Button
                  className="pull-right btnNewBrandPOS"
                  variant="contained"
                  id="nextButton"
                  onClick={this.handleNext}
                >{stepIndex === RECEIVE_PRODUCT_QNT_STEP ? 'Finish' : 'Next'}</Button>
                {stepIndex != 0 &&

                  <Button
                    className="pull-right"
                    variant="text"
                    onClick={this.handlePrev}
                    sx={{ marginRight: 12 }}
                    disabled={stepIndex === SCAN_UPC_NUMBER_STEP}
                  >
                    Back
                  </Button>
                }
                {(this.state.productInfo.upc && stepIndex === SCAN_UPC_NUMBER_STEP) &&
                  <Button
                    className="pull-right"
                    variant="text"
                    onClick={this.clearHandleUpc}
                    sx={{ marginRight: 12 }}
                  >
                    Clear
                  </Button>
                }
              </div>
            </div>
          )}
        </div>
        <DialogConfirm title={LOOKUP.pos.confirmOverwriteUPCDialog.title} isOpen={this.props.receivePOBarcodeExist}
          message={LOOKUP.pos.confirmOverwriteUPCDialog.message + this.props.receivePOUPCExistProductName}
          onConfirm={() => this.changeUPCandReceive()}
          onCancel={() => this.cancelChangeUPC()}
        />
      </div>
    );
  }
}

function mapStatetoProps(state) {
  return {
    isMedical: state.common.applicationSettings.isMedical,
    isVape: state.common.applicationSettings.isVape,
    receivePOBarcodeExist: state.form.receivePOBarcodeExist || false,
    receivePOUPCExistProductName: state.form.receivePOUPCExistProductName || null,
    receiveProductSuccessKey: state.form.receiveProductPOSaveSuccessKey,
    store: state.common.store,
    printQuantity: state.form.labelQuantityProductBarcode,
    expirationDate: state.form.receivedQuantityExpirationDate ? new Date(state.form['receivedQuantityExpirationDate']) : null,
    receivedPOProduct: state.entity.receivedPOProduct
  };
}

function mapDispatchToProps(dispatch) {
  return {
    showError: (message) => dispatch(showError(message)),
    clearFormInput: (name) => dispatch(clearFormInput(name)),
    getPurchaseOrderProduct: (id) => dispatch(getPurchaseOrderProduct(id))
  };
}

export default connect(mapStatetoProps, mapDispatchToProps)(ReceiveProductDialog);
